import { render, staticRenderFns } from "./ImportHistory.vue?vue&type=template&id=4bc14758&scoped=true"
import script from "./ImportHistory.vue?vue&type=script&lang=js"
export * from "./ImportHistory.vue?vue&type=script&lang=js"
import style0 from "./ImportHistory.vue?vue&type=style&index=0&id=4bc14758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc14758",
  null
  
)

export default component.exports